import React, { Component } from 'react' 
import axios from 'axios';  
// import Chartist from 'chartist'; 
 
const Chartist = window.Chartist;
 
 
//console.log( window.Chartist)

/**   fetch('/public/assets/json/MPIHedgeFundIndices.json') 
   .then((res) => {
    console.log(res)
 }) */ 

// var data = window.Indices ? window.Indices : { items: [] }
// console.log(data) 
 

// var items =me.state.data.items ?me.state.data.items : []

export default class MPIHedgeFundIndices extends Component {
    // 
    constructor(props) {
        super(props);
        this.state = {
            data:  { items: [] },
            items: [],
            chartItems: []
        }
        this.chartInit = this.chartInit.bind(this)
        this.barChartInit = this.barChartInit.bind(this)
        this.tableShow = this.tableShow.bind(this)
        // this.renderChartItems = this.renderChartItems.bind(this)
        this.renderLegend = this.renderLegend.bind(this);
        this.getDisclaimerText = this.getDisclaimerText.bind(this);
    }
    // 
    genCharArray(charA, charZ) {
        var a = [], i = charA.charCodeAt(0), j = charZ.charCodeAt(0);
        for (; i <= j; ++i) {
            a.push(String.fromCharCode(i));
        }
        return a;
    }
    getDisclaimerText() {
        return(
            <span><strong>Disclaimer:</strong> The accompanying footnotes and disclaimers found at the bottom of this page are an integral part of these charts, graphs and perfomance figures.</span>
        );
    }
    /*renderChartItems() {
        const chartItems = this.state.chartItems?this.state.chartItems:[]; 
        const c = this.genCharArray('a', 'z');
        // console.log(c)
        return (<div className="chart-items">{ chartItems.map ((entry,index)=>{
            return (<span key={index} className="span-legend">
               <svg height="5" width="40">
                    <line x1="10" y1="0" x2="10" y2="20" 
                        className={`leg-series-${c[index]}`} 
                        style={{strokeWidth:'50'}} />
                    Sorry, your browser does not support inline SVG.
                </svg>
                {entry.name}
            </span>)
        })}</div>)
    }
    renderBarChartItems() {
        const barItems = this.state.barItems?this.state.barItems:[]; 
        const c = this.genCharArray('a', 'z');
        // console.log(c)
        return (<div className="chart-items">{ barItems.map ((entry,index)=>{
            return (<span key={index} className="span-legend">
               <svg height="5" width="40">
                    <line x1="10" y1="0" x2="10" y2="20" 
                        className={`leg-series-${c[index]}`} 
                        style={{strokeWidth:'50'}} />
                    Sorry, your browser does not support inline SVG.
                </svg>
                {entry.name}
            </span>)
        })}</div>)        
    }*/
    renderLegend(chartType) {

        if (!chartType) return '';

        let items = null;

        if ( chartType === 'chart' ) {
            items = this.state.chartItems ? this.state.chartItems : []; 
        } else if ( chartType === 'bar' ) {
            items = this.state.barItems ? this.state.barItems : []; 
        }

        if ( !items ) {
            return '';
        }

        const c = this.genCharArray('a', 'z');
        // console.log(c)
        return (
            <div className="legend-wrapper">
                <div className="legend-wrapper__labels">
                { items.map ((entry,index)=>{
                    return (
                            <div key={index} className="span-legend">
                                <svg height="5" width="40">
                                    <line x1="10" y1="0" x2="10" y2="20" 
                                        className={`leg-series-${c[index]}`} 
                                        style={{strokeWidth:'50'}} />
                                    Sorry, your browser does not support inline SVG.
                                </svg>
                                {entry.name}
                            </div>
                        )
                    })
                }
                </div>
                <div className="legend-wrapper__disclaimer">{this.getDisclaimerText()}</div>
            </div>
        );
    }
    chartInit(load) {
       const me = this; 
        setTimeout(function (t) { 
            // SVG Path animation graph
            const items = me.state.data.items? me.state.data.items : [];
            // const inceptionDate
            var chart = items[1];
           
            const inceptionDate = chart["Inception date"]? chart["Inception date"]: null;
            const livePeriod = chart["Live Period"]? chart["Live Period"]: "Live Period";
            //const preInceptionPeriod = chart["Pre-inception Period"]? chart["Pre-inception Period"]: "Pre-inception Period";
           
            var cItems = chart.items;
            // console.log(cItems)
            me.setState({
                chartItems: cItems
            })
            var labels = items[1].items[0].data;
            const uniqueLabels = [...new Set(labels.map(e => e.date))]
            // console.log(uniqueLabels)  
            var series = [];
            var names = [];
            var maxValue = 100;
            cItems.map((i) => {
                const cid = i.data
                const item = cid.map(e => Number(e.value) === 0 ? null : Number(e.value))
                series.push(item);
                names.push(i.name)  
                return i;
            }) 
            series.map((items) => {  
                items.map((item) => {
                    if (item > maxValue) {maxValue = item } 
                    return item;
                })
                return items;
            })
           
            var inceptionSeries = [];
            var inception = false;
            uniqueLabels.map((label,idx) => {   
                if (inceptionDate.indexOf(label) > -1 && inceptionDate === label ) {
                    // console.log(label)
                    inception = true;
                } 
                if (idx === uniqueLabels.length-1 ) {
                    inceptionSeries.push({value:0, meta:0})
                }
                else if (inception) {
                    inceptionSeries.push( {value:maxValue, meta:maxValue}) 
                }
                else {
                    inceptionSeries.push({value:0, meta:0})
                }  
                return label;
            }) 
            series.push(inceptionSeries)  
            var responsiveOptions = [
                ['screen and (max-width: 640px)', {
                    seriesBarDistance: 5,
                    axisX: {
                        labelInterpolationFnc: function (value, index) {
                            return index % 24 === 0 ? value : null;
                        }
                    } 
                }],
                ['screen and (max-width: 340px)', {
                    seriesBarDistance: 5,
                    axisX: {
                        labelInterpolationFnc: function (value, index) {
                            return index % 36 === 0 ? value : null;
                        }
                    }
                }]
            ];
            // console.log(series)
            var charti = new Chartist.Line('.ct-svg-chart', {
                labels: uniqueLabels ? uniqueLabels : ['1', '2', '3', '4', '5', '6', '7'],
                series: [ 
                    { name: names[0], data: series[0]},
                    { name: names[1], data: series[1]},
                    { name: names[2], data: series[2]},
                    { name: names[3], data: series[3]},
                    { name: 'series-5', data: series[4]} 
                ]
                }, {
                    series: { 
                        [names[0]]: {
                            lineSmooth: Chartist.Interpolation.simple(),
                            showArea: false
                        },
                        [names[1]]:{
                            lineSmooth: Chartist.Interpolation.simple(),
                            showArea: false
                        },
                        [names[2]]:{
                            lineSmooth: Chartist.Interpolation.simple(),
                            showArea: false
                        },
                        [names[3]]: {
                            lineSmooth: Chartist.Interpolation.simple(),
                            showArea: false
                        },     
                        'series-5': {
                            lineSmooth: Chartist.Interpolation.step(),
                            showArea: true,
                            showLabel: true,
                            showPoint: false,
                        }, 
                      
                    },
                    low: 0,
                    high: maxValue,
                    showPoint: true,
                    fullWidth: true,
                    //plugins: [
                    //    Chartist.plugins.tooltip()
                    //] 
                    plugins: [
                        Chartist.plugins.tooltip({
                            appendToBody: true,
                            pointClass: 'cool-point'
                          }) 
                    ],
                    axisY: {
                        labelInterpolationFnc: function skipLabels(value, index) {
                            return index % 2 === 0 ? value : null;
                        }
                    },
                    axisX: {
                        labelInterpolationFnc: function skipLabels(value, index) {
                            return index % 12 === 0 ? value : null;
                        }
                    }
                }, responsiveOptions);


            charti.on('draw', function (data) {
                if (data.type === 'line' || data.type === 'area') {
                     
                    data.element.animate({
                        d: {
                            begin: 1000 * data.index,
                            dur: 2000,
                            from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
                            to: data.path.clone().stringify(),
                            easing: Chartist.Svg.Easing.easeOutQuint
                        }
                    });   

                    if (data.type === 'area' && data.series.name === 'series-5') {
                        var label, firstLabel; // barHorizontalCenter, barVerticalCenter, label, value;
                        // console.log(data,data.element.height()) 
                        label = new Chartist.Svg('text');
                        firstLabel = new Chartist.Svg('text');
                        label.text(livePeriod);  // "Live Period";
                        //firstLabel.text(preInceptionPeriod); // "Pre-inception Period";
                        // const middle = data.path.pathElements.length/2
                        // console.log( middle.toFixed(0), data.path.pathElements[ middle.toFixed(0) ] ) 
                        label.attr({
                            x: data.path.pathElements[ data.path.pathElements.length - 14 ].x,
                            y: data.chartRect.y1 - 8,
                            'text-anchor': 'middle'
                        });
                        label.addClass("ct-barlabel"); 

                        firstLabel.attr({
                            x: data.path.pathElements[ data.path.pathElements.length - 140 ].x,
                            y: data.chartRect.y1 - 8,
                            'text-anchor': 'middle'
                        }); 
                        firstLabel.addClass("ct-barlabel");  
                        data.group.append(firstLabel);  
                        return data.group.append(label);
                    }
                }
                if (data.type === 'point') {
                    // console.log(data)
                    const name = data.series.meta?data.series.meta:data.series.name;
                    const date = uniqueLabels[data.index];
                    var circle = new Chartist.Svg('circle', {
                        cx: [data.x],
                        cy: [data.y],
                        r: [1],
                        'ct:value': `${name}: <b>${(Number(data.value.y).toFixed(2))}</b>`, // data.value.y, //  label.text(Number(value).toFixed(2) + "%"); 
                        'ct:meta': `<b>${date}</b>`,
                        class: 'cool-point',
                      }, 'ct-svg-chart');
                  
                      // With data.element we get the Chartist SVG wrapper and we can replace the original point drawn by Chartist with our newly created triangle
                      data.element.replace(circle);
                } 
                
                
            })
   
        }, 100)
    }
    //
    barChartInit(load) {
        const me = this; 
        const items = me.state.data.items? me.state.data.items : []
        var barChart = items[3];
        // console.log(barChart)
        var cItems = barChart.items;
        me.setState({
            barItems: cItems
        })
        var labels = barChart.items[0].data;
        const uniqueLabels = [...new Set(labels.map(e => e.date))]
        var series = []
        cItems.map((i) => {
            const cid = i.data
            const items = cid.map(e => Number(e.value))
            series.push(items)
            return i;
        })

        // console.log(series)
        // Bar chart

        var data = {
            labels: uniqueLabels ? uniqueLabels : [],
            series: [
                ...series
            ]
        };

        var options = {
            seriesBarDistance: 20,
            axisY: {
                labelInterpolationFnc: function skipLabels(value, index) {
                    return value;
                    // if (index == 0) return value;
                    //else            return index % 2 === 0 ? value : null;
                }
            },
        };

        var responsiveOptions = [
            ['screen and (max-width: 640px)', {
                seriesBarDistance: 12,
                // axisX: {
                //     labelInterpolationFnc: function (value) {
                //         return value[0];
                //     }
                // }
            }]
        ];

        var chart = new Chartist.Bar('.ct-bar-chart', data, options, responsiveOptions);

        chart.on('draw', function (data) {
            var barHorizontalCenter, barVerticalCenter, label, value;
            if (data.type === "bar") {
                value = data.element.attr('ct:value');
                // barHorizontalCenter = data.x1 + (data.element.width() * .5);
                barHorizontalCenter = data.x1;
                // console.log(Number(value)) 
                if (Number(value) >= 0) {
                    barVerticalCenter = data.y1 + (data.element.height() * -1) - 10;
                }
                else if (Number(value) < 0) {
                    barVerticalCenter = data.y1 + (data.element.height() * 1) + 15;
                }
                else {
                    barVerticalCenter = data.y1 + (data.element.height() * -1) - 10;
                }


                if (value !== '0') {
                    label = new Chartist.Svg('text');
                    // label.text(Number(value).toFixed(2) + "%"); // 2 decimal 
                    label.text(Number(value).toFixed(1) ); // 1 decimal 
                    label.addClass("ct-barlabel");
                    label.attr({
                        x: barHorizontalCenter,
                        y: barVerticalCenter,
                        'text-anchor': 'middle'
                    });
                    return data.group.append(label);
                }
            }
        }); 
    }
    // 
    tableShow(i) {
        const me = this;
        const items = me.state.data.items ?  me.state.data.items : []
        var tData = items[i] ? items[i] : [];
        const rows = tData.rows ? tData.rows : [];
        const tid = i;
        // console.log(rows)
        const tableRows = rows[0] ? Object.keys(rows[0]) : []
        return (
            <table className="data">
                <thead>
                    <tr>
                        {
                            tableRows.map((r, i) => {
                                return (<td key={i}>{r}</td>)
                            })
                        }

                    </tr>
                </thead>
                <tbody>
                    {rows.map((r, i) => {
                        const tr = Object.keys(r);
                        var ap = '%';  
                        return (
                            <tr key={i}>
                                {tr.map((t, k) => {
                                      if (t === "Sharpe Ratio") { 
                                          ap = '';  
                                      } else {
                                          ap = '%';  
                                      }
                                    //   return (<td key={k}>{(Number(r[t])? `${ Number(r[t]).toFixed(2) }${ap}`:`${r[t]}${tid === 0 && k === 0 && i === 0?"*":""}`)}</td>)
                                    return (<td key={k}>{(Number(r[t])? `${ Number(r[t]).toFixed(2) }${ap}`:`${r[t]}${tid === 0 && k === 0 && i === 0?"":""}`)}</td>)
                                })}
                            </tr>
                        )

                    })}

                </tbody>
            </table>
        )
    }

    componentDidMount() {
        const me = this;  
        axios.get(`/charts/MPIHedgeFundIndicesMBEST20.json`)
            .then(res => {
               // console.log(res) 
                me.setState({
                    data:  res.data,
                    items: res.data.items
                }, function() {
                   me.chartInit(true);
                   me.barChartInit(true)
                }) 
        })   
    
    }
    componentWillMount() {
    }

    render() {
        const me = this; 
        const items = me.state.data.items ? me.state.data.items : []
        var chartName = items[1] && items[1].title ? items[1].title : 'Chart Title'
        var barName = items[3] && items[3].title ? items[3].title : 'Chart Title'
        var tableOneName = items[0] && items[0].title ? items[0].title : 'Table Title'
        var tableTwoName = items[2] && items[2].title ? items[2].title : 'Table Title'
        return (
            <div className="indices-charts">

               <div className="stat-table-container">
                <h4 className="card-title" style={{ textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: tableOneName }}></h4>
                    {this.tableShow(0)}
                    <div className="table-legend">
                        <p style={{fontSize: "13px", lineHeight: "21px", color: "rgba(0,0,0,.6)"}}>  
                            {this.getDisclaimerText()}
                        </p>
                    </div>
                </div>

                <div className="card-body">
                    <h4 className="card-title" style={{ textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: chartName }}></h4>
                     <div className="ct-svg-chart" style={{ minHeight: '400px', height: '400px', width: '100%' }}></div>
                     <div className="chart-legend">{this.renderLegend('chart')}</div>
                </div>


                <div className="stat-table-container">
                <h4 className="card-title" style={{ textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: tableTwoName }}></h4>
                    {this.tableShow(2)}
                    <div className="table-legend">
                        <p style={{fontSize: "13px", lineHeight: "21px", color: "rgba(0,0,0,.6)"}}>  
                            {this.getDisclaimerText()}
                        </p>
                    </div>
                </div>

                <div className="chart-body">
                    <h4 className="card-title" style={{ textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: barName }}></h4>
                    <div className="ct-bar-chart" style={{ minHeight: '400px', height: '400px', width: '100%' }}></div>
                    <div className="chart-legend">{this.renderLegend('bar')}</div>
                </div> 

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Charts/MPIHedgeFundIndices.js